module.exports = __webpack_public_path__ + "img/sample-forecast.3a0617ce.jpg";